import { faCogs, faIndustry, faPeopleArrows, faProjectDiagram, faPuzzlePiece, faServer, faTable, faUserTie, faBucket, faDatabase } from "@fortawesome/free-solid-svg-icons"
import { RouteLink } from "../../../types/route-link"

const superAdminRouteLinks: Array<RouteLink> = [
  {
    path: "/sectors",
    name: "Sectors",
    icon: faIndustry,
  },
  {
    path: "/clients",
    name: "Clients",
    icon: faPeopleArrows,
  },
  {
    path: "/admins",
    name: "Admins",
    icon: faUserTie,
  },
  {
    path: "/widget-management",
    name: "Widget Management",
    icon: faPuzzlePiece,
  },
  {
    path: "/file-management",
    name: "File Management",
    icon: faBucket,
  },
  {
    path: "/db-management",
    name: "Database Management",
    icon: faDatabase,
  },
  {
    path: "/bi-server",
    name: "BI Server",
    icon: faServer,
  },
  {
    path: "/analytics",
    name: "Analytics",
    icon: faProjectDiagram,
  },
  {
    path: "/settings",
    name: "Settings",
    icon: faCogs,
  },
];

export default superAdminRouteLinks